import { useState, useEffect } from 'react'
import {
    DownloadPage,
    Wrap,
    Eyebrow,
    Title,
    Desc,
    Status,
    Spinner,
    Progress,
    ProgressFill,
    Stores,
    StoreButton,
    Foot,
} from './DownloadElement'

const IOS_URL = 'https://apps.apple.com/us/app/djado/id6502918814'
const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.abzyne.djado'
const REDIRECT_DELAY = 3000 // ms

const Download = () => {
    const [redirecting, setRedirecting] = useState(true)
    const [seconds, setSeconds] = useState(Math.ceil(REDIRECT_DELAY / 1000))

    useEffect(() => {
        const ua = navigator.userAgent || ''
        const isIPadOS = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1
        const isIOS = /iPad|iPhone|iPod/.test(ua) || isIPadOS
        const isAndroid = /Android/.test(ua)

        if (!isIOS && !isAndroid) {
            setRedirecting(false)
            return
        }

        const url = isIOS ? IOS_URL : ANDROID_URL
        const redirectTimer = setTimeout(() => {
            window.location.href = url
        }, REDIRECT_DELAY)

        const countdown = setInterval(() => {
            setSeconds((s) => (s > 1 ? s - 1 : 1))
        }, 1000)

        return () => {
            clearTimeout(redirectTimer)
            clearInterval(countdown)
        }
    }, [])

    return (
        <DownloadPage>
            <Wrap>
                <Eyebrow>#POURLACULTURE</Eyebrow>
                <Title>DJADO</Title>
                <Desc>
                    DJADO est une application mobile, tout public, qui célèbre la culture africaine 🌍.
                    Quiz, défis quotidiens, duels en temps réel et tournois sponsorisés.
                    Rejoignez-nous dans l'aventure 🚀
                </Desc>

                <Status aria-live='polite'>
                    {redirecting && <Spinner />}
                    <span>
                        {redirecting
                            ? `Redirection vers votre store dans ${seconds} s…`
                            : 'Téléchargez gratuitement — choisissez votre store'}
                    </span>
                </Status>

                {redirecting && (
                    <Progress aria-hidden='true'>
                        <ProgressFill $duration={REDIRECT_DELAY} />
                    </Progress>
                )}

                <Stores>
                    <StoreButton href={IOS_URL} rel='noopener'>
                        Télécharger sur
                        <svg width='22' height='22' viewBox='0 0 24 24' fill='#fff' aria-hidden='true'>
                            <path d='M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z' />
                        </svg>
                    </StoreButton>
                    <StoreButton href={ANDROID_URL} rel='noopener'>
                        Télécharger sur
                        <svg width='22' height='22' viewBox='0 0 24 24' aria-hidden='true'>
                            <path d='M3 20.5V3.5c0-.4.2-.7.5-.9L13.8 12 3.5 21.4c-.3-.2-.5-.5-.5-.9z' fill='#34A853' />
                            <path d='M16.8 9.2 13.8 12l3 2.8 3.5-2c.6-.4.6-1.3 0-1.7l-3.5-2z' fill='#FBBC04' />
                            <path d='M3.5 2.6 13.8 12l3-2.8L5.4 2.1c-.7-.4-1.5-.1-1.9.5z' fill='#EA4335' />
                            <path d='M13.8 12 3.5 21.4c.4.6 1.2.9 1.9.5l11.4-7.1L13.8 12z' fill='#4285F4' />
                        </svg>
                    </StoreButton>
                </Stores>

                <Foot>N° 1 sur la culture Africaine 🌍</Foot>
            </Wrap>
        </DownloadPage>
    )
}

export default Download
